import { useEffect } from 'react';
import api from '../services/api';

// Pages qui gèrent leur propre balise <title> (SEO ou titre spécifique)
const isSeoManaged = (path) =>
  path === '/' || path.startsWith('/offre') ||
  path.startsWith('/tutoriels') || path.startsWith('/telechargements');

const DynamicPageTitle = () => {
  useEffect(() => {
    if (isSeoManaged(window.location.pathname)) {
      return; // laisser Helmet gérer le titre SEO de la page
    }
    const loadPageTitle = async () => {
      try {
        // Try to fetch site settings
        const response = await api.get('/admin/settings/environment');
        if (response.data && response.data.site_title) {
          document.title = response.data.site_title;
        }
      } catch (error) {
        // If not available (user not logged in or settings don't exist), use default
        document.title = 'IPTV4KFR | Une Offre Pour Toute la Famille';
      }
    };

    loadPageTitle();
  }, []);

  return null; // This component doesn't render anything
};

export default DynamicPageTitle;
